import type { ArticleStatus } from "@/hooks/useAdminArticles";

interface Props {
  statusFilter: ArticleStatus | "all";
  onStatusChange: (s: ArticleStatus | "all") => void;
  search: string;
  onSearchChange: (s: string) => void;
  counts: { pending: number; published: number; rejected: number; total: number };
}

const tabs: { key: ArticleStatus | "all"; label: string; countKey: keyof Props["counts"] }[] = [
  { key: "all", label: "Tous", countKey: "total" },
  { key: "pending", label: "En attente", countKey: "pending" },
  { key: "published", label: "Publiés", countKey: "published" },
  { key: "rejected", label: "Rejetés", countKey: "rejected" },
];

const tabColors: Record<string, string> = {
  all: "bg-gray-900 text-white",
  pending: "bg-amber-500 text-white",
  published: "bg-green-500 text-white",
  rejected: "bg-red-500 text-white",
};

const tabInactive = "bg-white text-gray-600 border border-gray-200 hover:border-gray-300";

export default function AdminFilters({ statusFilter, onStatusChange, search, onSearchChange, counts }: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      {/* Tabs */}
      <div className="flex gap-2 flex-wrap">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onStatusChange(tab.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
              statusFilter === tab.key ? tabColors[tab.key] : tabInactive
            }`}
          >
            {tab.label}
            <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${
              statusFilter === tab.key ? "bg-white/20" : "bg-gray-100 text-gray-500"
            }`}>
              {counts[tab.countKey]}
            </span>
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="flex-1 relative">
        <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Rechercher un article, entrepreneur, source..."
          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-full text-sm focus:outline-none focus:border-orange-400 transition-colors bg-white"
        />
      </div>
    </div>
  );
}
